import React, { useCallback } from "react";
import { Typography, IconButton, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import clsx from "clsx";
import { useFileViewStyles } from "./styles";
import { FileViewProps } from "./types";

export function FileView(props: FileViewProps) {
	const {
		file,
		onRemove,
		onSelect,
		imgBackground,
		selected,
		children,
		className,
		...rest
	} = props;

	const classes = useFileViewStyles();

	const onClickRemove = useCallback(
		e => {
			e.stopPropagation();
			if (onRemove && file) onRemove(file);
		},
		[file, onRemove]
	);

	const onClick = useCallback(
		e => {
			e.stopPropagation();
			if (onSelect && file) onSelect(file);
		},
		[file, onSelect]
	);

	const filename = decodeURI(
		file instanceof File ? file.name : file.substring(file.lastIndexOf("/") + 1)
	);

	return (
		<Tooltip title={filename}>
			<div
				className={clsx(className, classes.root, {
					[classes.selected]: selected
				})}
				{...rest}
			>
				<Typography
					component="span"
					onClick={onClick}
					className={clsx(classes.filename, {
						[classes.selectable]: !!onSelect
					})}
				>
					{filename}
				</Typography>

				{onRemove && (
					<IconButton
						onClick={onClickRemove}
						className={classes.removeBtn}
						size="small"
					>
						<DeleteIcon aria-label="Delete" />
					</IconButton>
				)}
			</div>
		</Tooltip>
	);
}
